import React, {useMemo} from "react";

export const CalendarStickyHours = () => {

    const hourLabels = useMemo(() => {
        return Array.from({length: 24}, (_, hour) => ({
            value: hour,
            label: `${String(hour).padStart(2, '0')}:00`,
        }));
    }, []);

    return (
        <div className={'calendar-sticky-hours-rows'}>
            <div className={'calendar-hours-header-glass'}/>
            <div className={'calendar-sticky-hours'}>
                {hourLabels.map((hour) => (
                    <div key={hour.value} className={'calendar-hour-slot'}>
                        <span className={'calendar-hour-label'}>{hour.label}</span>
                    </div>
                ))}
            </div>
        </div>
    );
}